module.exports = __webpack_public_path__ + "media/images/undraw/reserve/email_campaign-abd45973baa3b583c00fc29b0efcf102.png";